import { TemplateFormEnum, TypeEvalEnum } from "../../../convex/schema";

export type EvaluationTitleAudience = "interne" | "candidat";

export interface EvaluationForTitle {
  typeEval: string;
  template?: string;
}

// "interne" = portails client/admin/évaluateur ; "candidat" = portail candidat.
// pami affiche un libellé neutre côté candidat pour ne pas nommer le test.
const FORM_TITLES: Partial<
  Record<TemplateFormEnum, Record<EvaluationTitleAudience, string>>
> = {
  [TemplateFormEnum.AUTODIAG]: {
    interne: "Autodiagnostic",
    candidat: "Autodiagnostic",
  },
  [TemplateFormEnum.EGOGRAMME]: {
    interne: "Egogramme",
    candidat: "Egogramme",
  },
  [TemplateFormEnum.PAMI]: {
    interne: "PAMI",
    candidat: "Test de personnalité",
  },
  [TemplateFormEnum.FIT_CULTUREL]: {
    interne: "PC Fit",
    candidat: "PC Fit",
  },
  [TemplateFormEnum.COPSOQ3]: {
    interne: "COPSOQ 3",
    candidat: "COPSOQ 3",
  },
  [TemplateFormEnum.REFERENTIEL_PAMI]: {
    interne: "Référentiel PAMI",
    candidat: "Référentiel PAMI",
  },
  [TemplateFormEnum.REFERENTIEL_FIT_CULTUREL]: {
    interne: "Référentiel PC Fit",
    candidat: "Référentiel PC Fit",
  },
};

export function getEvaluationTitle(
  evaluation: EvaluationForTitle,
  audience: EvaluationTitleAudience = "interne",
): string {
  if (evaluation.typeEval === TypeEvalEnum.FORM) {
    const titles = evaluation.template
      ? FORM_TITLES[evaluation.template as TemplateFormEnum]
      : undefined;
    return titles ? titles[audience] : "Questionnaire";
  }
  if (evaluation.typeEval === TypeEvalEnum.ENT_STRUCT) return "FairView";
  if (evaluation.typeEval === TypeEvalEnum.RESULTATS) return "Résultats";
  return "Évaluation In-Basket";
}
